import { ParticipantSetting } from '@gsp-wf/wf-process-model';
import { Component, ComponentFactoryResolver, ComponentRef, Inject, Injector, LOCALE_ID, OnInit, Optional, TemplateRef, ViewChild } from '@angular/core';
import { PickedResult } from '@farris/ui-lookup';
import { Observable, Subject, of } from 'rxjs';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ActionScope, OrganizationPotentialOwner } from '../organization-potential-owner/actionOrganizationScope';
import { BackwardRuleComponent } from '../backward-rule/backward-rule.component';
import { BsModalService } from '@farris/ui-modal';
import { OrganizationPotentialOwnerComponent } from '../organization-potential-owner/organization-potential-owner.component';
import { ProcessDesignerViewModel } from '../../app/process-designer.viewmodel';
import { UserActivity } from '@gsp-wf/wf-process-model';
import { ParticipantInfo } from '../participant/participant.info';

@Component({
  selector: 'lib-batch-set-properties',
  templateUrl: './batch-set-properties.component.html',
  styleUrls: ['./batch-set-properties.component.css'],
  providers: [
    WfLocalePipe,
  ]
})
export class BatchSetPropertiesComponent implements OnInit {

  groupIcon2 = '<i class="f-icon f-icon-lookup"></i>';
  submit = new Subject<string>();
  cancel = new Subject<any>();
  @ViewChild('footer') footer: TemplateRef<any>;
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  cols = [
    { title: this.localePipe.transform('component.batchSet.name'), field: 'Name', width: 60, searchField: 'Name' },
    { title: 'ID', field: 'Id', width: 90, searchField: 'Id' }];
  activityModel: any;
  useractivities = [];
  useroperationnotifyactivities = [];
  useroperationsubcatchactivities = [];
  actis1 = [];
  actis2 = [];
  actis3 = [];
  actis4 = [];
  actis5= [];
  addSignFrontActis = [];
  addSignBehindActis = [];
  transferActis = [];
  notifyActis = [];
  backWardRuleActis = [];
  participantOptionsActis = [];
  nullActis = [];
  addSignFrontEnable = false;
  addSignBehindEnable = false;
  transferEnable = false;
  notifyEnable = false;
  backWardRuleEnable = false;
  participantOptionsEnable = false;
  backWardRule = {};
  participantOptions = {};
  addSignFrontScope = {};
  addSignBehindScope = {};
  transferScope = {};
  notifyScope = {};
  pageInfo = {
    pageIndex: 1,
    pageList: [10, 20, 30, 50],
    pageSize: 20
  };
  total: number;
  constructor(
    public uistate: ProcessDesignerUIState,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private viewModel: ProcessDesignerViewModel,
  ) {
    // 过滤只有审批节点的
    this.useractivities = this.uistate.userActList.filter(function(item) {
      return item.ClrTypeID === UserActivity.Clr_Type_ID;
  })
    // 拼接审批+人工+知会
    this.useroperationnotifyactivities = [...this.uistate.userActList, ...this.uistate.NotifyActKist];
    // 拼接审批人工子流程信号捕获
    this.useroperationsubcatchactivities = [...this.uistate.userActList, ...this.uistate.SubAndCatchActList];
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
    const addSignFront = this.activityModel.dynamicParticipants.filter(function(participant) {
      return participant.actionScope === "AddSignFront";
    });
    const addSignBehind = this.activityModel.dynamicParticipants.filter(function(participant) {
      return participant.actionScope === "AddSignBehind";
    });
    const transfer = this.activityModel.dynamicParticipants.filter(function(participant) {
      return participant.actionScope === "Transfer";
    });
    const notify = this.activityModel.dynamicParticipants.filter(function(participant) {
      return participant.actionScope === "Notify";
    });
    if(!addSignFront[0] || addSignFront[0].organizationLevel) {  
      this.addSignFrontScope = {
        enable: this.activityModel.AddSignFrontAble,
        action: "AddSignFront",
        scope: addSignFront[0]
      }
    } else {
      let scope = new OrganizationPotentialOwner();
      let participant = new ParticipantInfo();
      participant.potentialOwnerList = addSignFront;
      participant.isAllScope = true;//反的
      scope.participantInfo = participant;
      this.addSignFrontScope = {
        enable: this.activityModel.AddSignFrontAble,
        action: "AddSignFront",
        scope: scope
      }
    };
    if(!addSignBehind[0] || addSignBehind[0].organizationLevel) {  
      this.addSignBehindScope = {
        enable: this.activityModel.AddSignBehindAble,
        action: "AddSignBehind",
        scope: addSignBehind[0]
      }
    } else {
      let scope = new OrganizationPotentialOwner();
      let participant = new ParticipantInfo();
      participant.potentialOwnerList = addSignBehind;
      participant.isAllScope = true;//反的
      scope.participantInfo = participant;
      this.addSignBehindScope = {
        enable: this.activityModel.AddSignBehindAble,
        action: "AddSignBehind",
        scope: scope
      };
    }
    if(!transfer[0] || transfer[0].organizationLevel) {  
      this.transferScope = {
        enable: this.activityModel.transferAble,
        action: "Transfer",
        scope: transfer[0]
      };
    } else {
      let scope = new OrganizationPotentialOwner();
      let participant = new ParticipantInfo();
      participant.potentialOwnerList = transfer;
      participant.isAllScope = true;//反的
      scope.participantInfo = participant;
      this.transferScope = {
        enable: this.activityModel.transferAble,
        action: "Transfer",
        scope: scope
      };
    }
    if(!notify[0] || notify[0].organizationLevel) {  
      this.notifyScope = {
        enable: this.activityModel.NotifyAble,
        action: "Notify",
        scope: notify[0]
      };
    } else {
      let scope = new OrganizationPotentialOwner();
      let participant = new ParticipantInfo();
      participant.potentialOwnerList = notify;
      participant.isAllScope = true;//反的
      scope.participantInfo = participant;
      this.notifyScope = {
        enable: this.activityModel.NotifyAble,
        action: "Notify",
        scope: scope
      };
    }
    this.backWardRule = this.activityModel.BackWardRule;
    this.participantOptions = this.activityModel.ParticipantSetting;
  }

  frontActisSelect = (rowData): Observable<PickedResult> => {
    this.addSignFrontActis = rowData;
    return of({
      closeDialog: true
    });
  }

  behindActisSelect = (rowData): Observable<PickedResult> => {
    this.addSignBehindActis = rowData;
    return of({
      closeDialog: true
    });
  }

  notifyActisSelect = (rowData): Observable<PickedResult> => {
    this.notifyActis = rowData;
    return of({
      closeDialog: true
    });
  }

  transferActisSelect = (rowData): Observable<PickedResult> => {
    this.transferActis = rowData;
    return of({
      closeDialog: true
    });
  }

  backWardRuleActisSelect = (rowData): Observable<PickedResult> => {
    this.backWardRuleActis = rowData;
    return of({
      closeDialog: true
    });
  }

  actisSelect = (rowData): Observable<PickedResult> => {
    return of({
      closeDialog: true
    });
  }

  // addSignFrontConfig() {
  //   const compFactory = this.resolver.resolveComponentFactory(OrganizationPotentialOwnerComponent);
  //   const compRef = compFactory.create(this.injector);
  //   compRef.instance.action = ActionScope.AddSignFront
  //   const orgModalConfig = {
  //     title: this.localePipe.transform('component.orgPotentialOwner.optionSettings'),
  //     width: 517,
  //     height: 382,
  //     showButtons: true,
  //     buttons: compRef.instance.modalFooter
  //   };
  //   const dialog = this.modalService.show(compRef, orgModalConfig);
  //   compRef.instance.closeModal.subscribe($event => dialog.close());
  //   compRef.instance.submitModal.subscribe((data: any) => {
  //     this.addSignFrontScope = data.value;
  //     this.frontPlaceholder = '（已设置）'
  //     dialog.close();
  //   });
  // }

  // addSignBehindConfig() {
  //   const compFactory = this.resolver.resolveComponentFactory(OrganizationPotentialOwnerComponent);
  //   const compRef = compFactory.create(this.injector);
  //   compRef.instance.action = ActionScope.AddSignBehind
  //   const orgModalConfig = {
  //     title: this.localePipe.transform('component.orgPotentialOwner.optionSettings'),
  //     width: 517,
  //     height: 382,
  //     showButtons: true,
  //     buttons: compRef.instance.modalFooter
  //   };
  //   const dialog = this.modalService.show(compRef, orgModalConfig); compRef.instance.closeModal.subscribe($event => dialog.close());
  //   compRef.instance.submitModal.subscribe((data: any) => {
  //     this.addSignBehindScope = data.value;
  //     this.behindPlaceholder = '（已设置）'
  //     dialog.close();
  //   });
  // }

  // transferConfig() {
  //   const compFactory = this.resolver.resolveComponentFactory(OrganizationPotentialOwnerComponent);
  //   const compRef = compFactory.create(this.injector);
  //   compRef.instance.action = ActionScope.Transfer
  //   const orgModalConfig = {
  //     title: this.localePipe.transform('component.orgPotentialOwner.optionSettings'),
  //     width: 517,
  //     height: 382,
  //     showButtons: true,
  //     buttons: compRef.instance.modalFooter
  //   };
  //   const dialog = this.modalService.show(compRef, orgModalConfig); compRef.instance.closeModal.subscribe($event => dialog.close());
  //   compRef.instance.submitModal.subscribe((data: any) => {
  //     this.transferScope = data.value;
  //     this.transferPlaceholder = '（已设置）'
  //     dialog.close();
  //   });
  // }

  // notifyConfig() {
  //   const compFactory = this.resolver.resolveComponentFactory(OrganizationPotentialOwnerComponent);
  //   const compRef = compFactory.create(this.injector);
  //   compRef.instance.action = ActionScope.Notify
  //   const orgModalConfig = {
  //     title: this.localePipe.transform('component.orgPotentialOwner.optionSettings'),
  //     width: 517,
  //     height: 382,
  //     showButtons: true,
  //     buttons: compRef.instance.modalFooter
  //   };
  //   const dialog = this.modalService.show(compRef, orgModalConfig);
  //   compRef.instance.closeModal.subscribe($event => dialog.close());
  //   compRef.instance.submitModal.subscribe((data: any) => {
  //     this.notifyScope = data.value;
  //     this.notifyPlaceholder = '（已设置）'
  //     dialog.close();
  //   });
  // }

  // backWardRuleConfig() {
  //   const compFactory = this.resolver.resolveComponentFactory(BackwardRuleComponent);
  //   const compRef = compFactory.create(this.injector);
  //   compRef.instance.editorParams.nodeType = 'UserActivity';
  //   const modalConfig = {
  //     title: this.localePipe.transform('component.backwardRule.backwardRule'),
  //     width: 760,
  //     height: 505,
  //     buttons: compRef.instance.modalFooter
  //   };
  //   const dialog = this.modalService.show(compRef, modalConfig);
  //   compRef.instance.closeModal.subscribe($event => dialog.close());
  //   compRef.instance.submitModal.subscribe((data: any) => {
  //     this.backWardRule = data.value;
  //     this.backWardPlaceholder = '（已设置）'
  //     dialog.close();
  //   });
  // }

  clickOK() {
    const value = [];
    if (this.addSignFrontEnable) {
      const frontData = {
        type: 'addSignfront',
        actis: this.addSignFrontActis,
        config: this.addSignFrontScope
      }
      value.push(frontData)
    }
    if (this.addSignBehindEnable) {
      const behindData = {
        type: 'addSignBehind',
        actis: this.addSignFrontActis,
        config: this.addSignBehindScope
      }
      value.push(behindData)
    }
    if (this.transferEnable) {
      const transferData = {
        type: 'transfer',
        actis: this.addSignFrontActis,
        config: this.transferScope
      }
      value.push(transferData)
    }
    if (this.notifyEnable) {
      const notifyData = {
        type: 'notify',
        actis: this.addSignFrontActis,
        config: this.notifyScope
      }
      value.push(notifyData)
    }
    if (this.backWardRuleEnable) {
      const backWardRuleData = {
        type: 'backWardRule',
        actis: this.addSignFrontActis,
        config: this.backWardRule
      }
      value.push(backWardRuleData)
    }
    if(this.participantOptionsEnable) {
      const participantOptionsData = {
        type: 'participantOptions',
        actis: this.addSignFrontActis,
        config: this.participantOptions
      }
      value.push(participantOptionsData)
    }
    if (value && value.length > 0) {
      this.batchSet(value);
    }
    this.submit.next();
  }

  clickCancel() {
    this.cancel.next();
  }

  batchSet(value: any) {
    this.viewModel.batchSet(ResourceKeys.batchSetProperty, value);
  }

}

export enum ResourceKeys {
  batchSetProperty = 'batchSetProperty'
}
